export type fileNameMapType = {
    sac_nt_daily_benchmark: string;
}

export const fileNameMap: fileNameMapType = {
    sac_nt_daily_benchmark: "Daily Benchmark"
}